import React, { useEffect, useRef, useState, createRef } from "react";
import Select, { components } from "react-select";
import styled from "styled-components";
import Search from '@material-ui/icons/Search';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
const CustomInput = styled.input`
  display: flex;
  align-items: center;
  width: 100%;
  &:focus-visible {
    outline: none !important;
  }
`;

const useStyles = makeStyles((theme) => ({
  dropdown: {
    width: 200,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    border: '1px solid',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  dropDown: {
    width: '100%',
    borderColor: 'red'

  },
  pointerEventNone: {
    pointerEvents: 'none'
  },
  freeStyle: {
    width: '100% !important',
  }
}));

const { MenuList, ValueContainer, SingleValue, Placeholder } = components;

const CustomMenuList = ({ selectProps, ...props }) => {
  const { onInputChange, inputValue, onMenuInputFocus, searchInpValue, enableSearch } = selectProps;
  const { t } = useTranslation();
  // Copied from source
  const ariaAttributes = {
    "aria-autocomplete": "list",
    "aria-label": selectProps["aria-label"],
    "aria-labelledby": selectProps["aria-labelledby"]
  };

  const classes = useStyles();

  return (
    <div>
      {enableSearch && <span style={{ display: 'flex', alignItems: 'center', }}>
        <Search style={{ position: 'absolute', fontSize: '15px', marginLeft: '5px' }} />
        <CustomInput
          className="searchInp-inside-select"
          autoCorrect="off"
          autoComplete="off"
          spellCheck="false"
          type="text"
          value={inputValue}
          onChange={(e) =>
            onInputChange(e.currentTarget.value, {
              action: "input-change"
            })
          }
          onMouseDown={(e) => {
            e.stopPropagation();
            e.target.focus();
          }}
          onTouchEnd={(e) => {
            e.stopPropagation();
            e.target.focus();
          }}
          onFocus={onMenuInputFocus}
          placeholder={t('dropdown.search')}
          {...ariaAttributes}
        />
      </span>
      }
      <MenuList {...props} selectProps={selectProps} />
    </div>
  );
};

// Set custom `SingleValue` and `Placeholder` to keep them when searching
const CustomValueContainer = ({ children, selectProps, ...props }) => {
  const commonProps = {
    cx: props.cx,
    clearValue: props.clearValue,
    getStyles: props.getStyles,
    getValue: props.getValue,
    hasValue: props.hasValue,
    isMulti: props.isMulti,
    isRtl: props.isRtl,
    options: props.options,
    selectOption: props.selectOption,
    setValue: props.setValue,
    selectProps,
    theme: props.theme
  };

  return (
    <ValueContainer {...props} selectProps={selectProps}>
      {React.Children.map(children, (child) => {
        return child ? (
          child
        ) : props.hasValue ? (
          <SingleValue
            {...commonProps}
            isFocused={selectProps.isFocused}
            isDisabled={selectProps.isDisabled}
          >
            {selectProps.getOptionLabel(props.getValue()[0])}
          </SingleValue>
        ) : (
          <Placeholder
            {...commonProps}
            key="placeholder"
            isDisabled={selectProps.isDisabled}
            data={props.getValue()}
          >
            {selectProps.placeholder}
          </Placeholder>
        );
      })}
    </ValueContainer>
  );
};

// const Input = props => {
//   return <components.Input {...props} injectStyles={false} />;
// };
const DropdownWithBorders = (props) => {
  const classes = useStyles();

  const {
    onChange, //onchange function on changing select value
    selectOpts = [], //options that needs to be selected
    defaultValue, // default values that needs to be shown
    selectVal, // current value that needs to be displayed on select
    isDisabled, // to disabld the select //BOOLEAN
    isSearchable, // to enable disable //BOOLEAN
    onSearchInpChange, // to get the value typed inside search
    customFilterOption, // custom filter
    isLoading, // to displayloading icon,
  } = props;
  const containerRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [userInputVal, setUserInputVal] = useState("")
  console.log('userInputVal :', userInputVal);
  let myRef = createRef();

  const onDomClick = (e) => {
    let menu = containerRef.current.querySelector(".select__menu");

    if (
      !containerRef.current.contains(e.target) ||
      !menu ||
      !menu.contains(e.target)
    ) {
      setIsFocused(false);
      setInputValue("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", onDomClick);

    return () => {
      document.removeEventListener("mousedown", onDomClick);
    };
  }, []);


  function onKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      let menuIsOpen = false;
      menuIsOpen = myRef.current.props.menuIsOpen;
      if (menuIsOpen) {
        onSearchInpChange(inputValue, 'ENTERHIT');
      }
    }
  }


  const optionChange = (e) => {
    onChange(e);
    setIsFocused(false);
  }

  function onChangeInput(value) {
    setInputValue(value)
    if (!value) {
      onSearchInpChange(inputValue, 'EMPTY');
    }
  }

  const cache = createCache({
    key: 'css',
    nonce: document.querySelector('meta[property="csp-nonce"]')?.content || '',
  });
  return (
    <div id="dropDown" className={classes.dropDown} ref={containerRef}>
      <CacheProvider value={cache}>
        <Select
          // nonce={nonceValue}
          styles={{
            menuList: (base) => ({
              ...base,
              "::-webkit-scrollbar": {
                width: "4px",
                height: "30px",
              },
              "::-webkit-scrollbar-track": {
                background: "#F1F1F1"
              },
              "::-webkit-scrollbar-thumb": {
                background: "#888"
              },
              "::-webkit-scrollbar-thumb:hover": {
                background: "#555"
              }
            }),
            dropdownIndicator: (provided, state) => ({
              ...provided,
              transform: state.selectProps.menuIsOpen && "rotate(180deg)",
            }),
            control: (styles, state) => ({
              ...styles,
              width: '100% !important',
              maxWidth: '100%',
              border: state.isFocused ? 'solid 2px #2684FF !important' : (props.error ? 'solid 0 #f44336 !important' : ''),
              boxShadow: state.isFocused ? '0 0 0 0 #2684FF !important' : (props.error ? '0 0 0 1px #f44336 !important' : ''),
            }),
          }}
          onKeyDown={onKeyDown}
          ref={myRef}
          isDisabled={isDisabled}
          isLoading={isLoading}
          className={`${classes.freeStyle} basic-single`}
          classNamePrefix="select"
          name="color"
          enableSearch={isSearchable}
          options={selectOpts}
          components={{
            MenuList: CustomMenuList,
            //ValueContainer: CustomValueContainer,
            IndicatorSeparator: null,
          }}
          maxMenuHeight={200}
          value={selectVal}
          menuIsOpen={isFocused}
          inputValue={inputValue}
          searchInpValue={userInputVal}
          isSearchable={false}
          onMenuInputFocus={() => setIsFocused(true)}
          onChange={optionChange}
          onInputChange={isSearchable ? onChangeInput : false}
          defaultValue={defaultValue}
          {...{
            menuIsOpen: isFocused || undefined,
            isFocused: isFocused || undefined
          }}
          filterOption={customFilterOption}
          blurInputOnSelect
        />
      </CacheProvider>
    </div>
  );
};

export default DropdownWithBorders;
